export default {
    HOME: 1,
    FATURAMENTO: 2,
    MEUS_CARROS: 3,
    CONTATOS: 4,

    properties: {
        1: {
            acesso: 0,
            login: 1
        },
        2: {
            acesso: 0,
            download: 1,
            copiaCodigoBarras: 2
        },
        3: {
            acesso: 0,
            informacao: 1
        },
        4: {
            whatsApp: 1,
            telefone: 2,
            email: 3
        }
    }
}